import { render, staticRenderFns } from "./Campaign2025.vue?vue&type=template&id=2c807b4a&"
import script from "./Campaign2025.vue?vue&type=script&lang=js&"
export * from "./Campaign2025.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports